import { IMAGES } from './supabaseImages';
import estudioImage from '../assets/WEB_SOLE_FOTO_COSTILLA_GROUP-05-web.webp';

export const CATEGORIAS = [
  { id: 'eventos', titulo: 'Eventos', imagen: IMAGES.home.img1 },
  { id: 'sesiones', titulo: 'Sesiones', imagen: IMAGES.boudoir },
  { id: 'estudio', titulo: 'Alquiler de estudio', imagen: estudioImage },
  { id: 'efectos', titulo: 'Efectos especiales', imagen: IMAGES.carousel.humo },
  { id: 'adicionales', titulo: 'Servicios adicionales', imagen: IMAGES.carousel.rosa },
  { id: 'otros', titulo: 'Otros servicios', imagen: null },
];

export const CATEGORIAS_POR_ID = CATEGORIAS.reduce(
  (acc, cat) => ({ ...acc, [cat.id]: cat }),
  {}
);

const ALIAS_SLUG = {
  'xv anos': 'mis-15',
  xv: 'mis-15',
  'mis 15': 'mis-15',
  mis15: 'mis-15',
  quince: 'mis-15',
  15: 'mis-15',
  estudio: 'alquiler-de-estudio',
  'alquiler de estudio': 'alquiler-de-estudio',
  'marca personal': 'marca-personal',
  boda: 'boda',
  bodas: 'boda',
};

export function normalizar(valor) {
  return String(valor || '')
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, ' ')
    .trim();
}

export function slugify(valor) {
  return normalizar(valor).replace(/\s+/g, '-');
}

export function resolverSlug(valor) {
  const base = normalizar(valor);
  if (!base) return '';
  if (ALIAS_SLUG[base]) return ALIAS_SLUG[base];
  return base.replace(/\s+/g, '-');
}

export function urlServicio(servicio) {
  if (!servicio) return '/';
  const slug = servicio.slug || resolverSlug(servicio.nombre);
  return `/servicios/${slug}`;
}

export function formatPrice(valor) {
  if (valor === null || valor === undefined || valor === '') return null;
  const number = Number(valor);
  if (Number.isNaN(number)) return null;
  return new Intl.NumberFormat('es-AR', {
    style: 'currency',
    currency: 'USD',
    maximumFractionDigits: 0,
  }).format(number);
}

export function agruparPorCategoria(servicios) {
  return CATEGORIAS.map((cat) => ({
    ...cat,
    items: (servicios || [])
      .filter((s) => (s.categoria || 'otros') === cat.id)
      .sort((a, b) => (a.orden || 0) - (b.orden || 0)),
  })).filter((grupo) => grupo.items.length > 0);
}

/* Catálogo de respaldo: se usa solo si la tabla `servicios` todavía no
   tiene filas (por ejemplo, antes de aplicar la migración). */
export const SERVICIOS_SEED = [
  { nombre: 'XV años', categoria: 'eventos', orden: 0 },
  { nombre: 'Bodas', categoria: 'eventos', orden: 1 },
  { nombre: 'Aniversarios', categoria: 'eventos', orden: 2 },
  { nombre: 'Cumpleaños temáticos', categoria: 'eventos', orden: 3 },
  { nombre: 'Infantiles', categoria: 'eventos', orden: 4 },
  { nombre: 'Familia', categoria: 'eventos', orden: 5 },
  { nombre: 'Comuniones', categoria: 'eventos', orden: 6 },
  { nombre: 'Bautismo', categoria: 'eventos', orden: 7 },
  { nombre: 'Baby showers', categoria: 'eventos', orden: 8 },
  { nombre: 'Revelación de género', categoria: 'eventos', orden: 9 },
  { nombre: 'Otros', categoria: 'eventos', orden: 10 },

  { nombre: 'New born (recién nacidos)', categoria: 'sesiones', orden: 0, nota: 'Estilo libre' },
  { nombre: 'Maternidad', categoria: 'sesiones', orden: 1 },
  { nombre: 'Pre cumple', categoria: 'sesiones', orden: 2 },
  { nombre: 'Pre boda', categoria: 'sesiones', orden: 3 },
  { nombre: 'Post boda', categoria: 'sesiones', orden: 4 },
  { nombre: 'Pre XV', categoria: 'sesiones', orden: 5 },
  { nombre: 'Post XV', categoria: 'sesiones', orden: 6 },
  { nombre: 'Pre comunión', categoria: 'sesiones', orden: 7 },
  { nombre: 'Boudoir', categoria: 'sesiones', orden: 8 },
  { nombre: 'Parejas', categoria: 'sesiones', orden: 9 },
  { nombre: 'Marca personal', categoria: 'sesiones', orden: 10 },
  { nombre: 'Producto', categoria: 'sesiones', orden: 11 },
  { nombre: 'Redes sociales', categoria: 'sesiones', orden: 12 },
  { nombre: 'Corporativo (equipos de trabajo)', categoria: 'sesiones', orden: 13 },
  { nombre: 'Sesiones de días especiales', categoria: 'sesiones', orden: 14 },

  { nombre: 'Alquiler de estudio', categoria: 'estudio', orden: 0 },

  { nombre: 'Chispas frías', categoria: 'efectos', orden: 0, opciones: ['2 máquinas', '4 máquinas'] },
  { nombre: 'Pistolas de CO2', categoria: 'efectos', orden: 1, opciones: ['1 pistola', '2 pistolas'] },

  { nombre: 'Servicio de video', categoria: 'adicionales', orden: 0 },
  { nombre: 'Espacio de fotos instantáneo', categoria: 'adicionales', orden: 1, nota: 'Montamos un estudio de fotos en tu evento' },
  { nombre: 'Tarjetas digitales', categoria: 'adicionales', orden: 2 },
];

/* Mismo seed mapeado al formato de tarjetas del sitio. */
export const CATEGORIAS_SERVICIOS = agruparPorCategoria(
  SERVICIOS_SEED.map((s) => ({ ...s, slug: resolverSlug(s.nombre) }))
).map((grupo) => ({
  id: grupo.id,
  title: grupo.titulo,
  imageUrl: grupo.imagen,
  items: grupo.items.map((item) => ({
    label: item.nombre,
    note: item.nota,
    options: item.opciones,
    slug: item.slug,
  })),
}));
